<template>
  <div>
    <div v-if="showNoti" class="notification">
      <div>
        <div class="noti-title">{{ noti.short_term_of_notification }}</div>
        <div class="noti-detile">{{ noti.long_term_of_notification }}</div>
      </div>
      <div>
        <div class="noti-more" @click="showNotification()">
          ดูเพิ่มเติม
        </div>
      </div>
    </div>

    <div class="header-select-battery">Select Slot</div>

    <div v-if="batteryStation.length > 1">
      <div class="container mb-12">
        <span v-for="(battery, i) in batteryStation" :key="i" @click="openBatteryModal(battery)">
          <Battery :battery="battery"></Battery>
        </span>
      </div>
    </div>

    <div v-else>
      <v-row no-gutters>
        <div class="station-loader" v-for="index in 5" :key="index">
          <v-col>
            <v-skeleton-loader class="left-col-loader" max-width="300" type="image" width="160"
              height="75"></v-skeleton-loader>
          </v-col>
          <v-col>
            <v-skeleton-loader class="right-col-loader" max-width="300" type="image" width="160"
              height="75"></v-skeleton-loader>
          </v-col>
        </div>
      </v-row>
    </div>

    <!-- email secretkey -->
    <!-- <div v-if="isModalOpen" class="modal"> -->
    <div v-if="isModalOpenSelectBattery" class="modal">
      <v-dialog v-model="dialogVisible" persistent max-width="325">
        <div class="modal-content">
          <img src="../assets/Swap.png" />
          <div style="margin: 24px 0;">
            <div class="modal-title">Are you sure you want to swap this locker ?</div>
            <div class="modal-detail">The locker will open after you confirm this locker.</div>
          </div>
          <div class="group-btn">
            <button @click="closeBatteryModal" class="cancel-btn">Cancel</button>
            <button @click="confirmRoute" class="confirm-btn">Confirm</button>
          </div>
        </div>
      </v-dialog>
    </div>
    <div v-else-if="isModalBatteryCharging" class="modal">
      <v-dialog v-model="dialogVisible" persistent max-width="325">
        <div class="modal-content">
          <img src="../assets/SwapCharging.png" />
          <div style="margin: 24px 0;">
            <div class="modal-title">Batteries is charging</div>
            <div class="modal-detail">Batteries in this locker is charging. Please wait until 80% or select
              other
              locker.
            </div>
          </div>
          <div class="group-btn">
            <button @click="closeBatteryModal" class="confirm-btn">Close</button>
          </div>
        </div>
      </v-dialog>
    </div>
    <div v-else-if="isModalBatteryNotAvailable" class="modal">
      <v-dialog v-model="dialogVisible" persistent max-width="325">
        <div class="modal-content">
          <img src="../assets/notAvailable.png" />
          <div style="margin: 24px 0;">
            <div class="modal-title">This locker is not available !</div>
            <div class="modal-detail">This locker can’t be use now. Please wait and try again later.</div>
          </div>
          <div class="group-btn">
            <button @click="closeBatteryModal" class="confirm-btn">Close</button>
          </div>
        </div>
      </v-dialog>
    </div>


    <div v-if="isNotification" class="modal">
      <v-dialog v-model="dialogVisible" persistent max-width="325">
        <div class="noti-content">
          <!-- <img src="../assets/Swap.png" /> -->
          <div style="margin: 24px 0;" class="">
            <div class="modal-title">{{ noti.short_term_of_notification }}</div>
            <div class="modal-detail">{{ noti.long_term_of_notification }}</div>
            <!-- <div class="modal-detail">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam culpa
              perspiciatis quidem tempora ut obcaecati amet maiores iste, excepturi beatae. Molestiae ex deserunt, harum
              ducimus dolore dolorum, nulla ut sint at velit itaque obcaecati sequi corrupti libero reiciendis neque
              natus alias odio, blanditiis molestias! Optio, quisquam officiis earum assumenda, minima debitis non
              veniam vel saepe, est hic unde nobis accusantium molestias? Expedita fuga, cupiditate error dolor
              molestias provident amet at, omnis doloribus sunt blanditiis, facilis laboriosam totam nobis sequi
              exercitationem quia eaque veritatis asperiores aliquid atque id temporibus. Ullam officia voluptates
              veritatis magni consectetur voluptate cum animi eum impedit totam? Ut molestiae accusantium nemo
              consequuntur excepturi aperiam labore ipsum quae natus, eveniet laboriosam impedit quisquam incidunt
              tempore dolorem voluptates aliquam facilis, exercitationem, harum quaerat esse! Error, deserunt quibusdam
              unde temporibus quas ipsa numquam necessitatibus dolor saepe vel consequuntur, dolores ratione fugit
              eligendi expedita incidunt? Inventore reprehenderit iste molestias, nihil atque mollitia, nobis explicabo,
              quod fugiat sint reiciendis consectetur eaque quis corrupti temporibus! Similique minus perspiciatis iste
              reprehenderit velit, repellat asperiores ab cumque, architecto nesciunt, nulla necessitatibus atque esse
              commodi sapiente? Pariatur voluptatem officia non facere, recusandae voluptatibus et eligendi perferendis
              deleniti. Illum vitae natus repellat voluptatum perferendis fuga, molestias sunt.
            </div> -->
          </div>
          <div class="group-btn">
            <button @click="closeBatteryModal" class="confirm-btn">Close</button>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Button from "../components/Button.vue"
import Battery from "../components/Battery.vue"
import CryptoJS from 'crypto-js'

export default {
  name: 'Station',
  components: {
    Button,
    Battery
  },
  data() {
    return {
      batteryStation: [],
      selectedBattery: null,
      isModalOpenSelectBattery: false,
      selectedBatteryForModal: null,
      isModalBatteryCharging: null,
      isModalBatteryNotAvailable: null,
      dialogVisible: true,
      intervalUpdate: undefined,
      isNotification: false,
      noti: null,
      showNoti: false,
      userId: "",
    }
  },
  methods: {
    encMessage(message) {
      if (!message) return ''
      return CryptoJS.AES.encrypt(message, "windeekisra").toString();
    },
    decMessage(message) {
      if (!message) return ''
      return CryptoJS.AES.decrypt(message, 'windeekisra').toString(CryptoJS.enc.Utf8);
    },
    async fetchData() {
      if (!this.$route.query.station) this.$router.push({ name: 'home' })
      try {
        let encoded = this.$route.query.station.replace(/ /g, '+')
        let stationId = this.decMessage(encoded)
        // console.log('station id: ', this.stationId)
        let response = await this.$apiFire('Station/onGetBatteryStation', stationId) // Station id
        // console.log('battery api ', response);
        this.batteryStation = response;
      } catch (error) {
        console.log(error);
      }
    },
    async getRentalNotification() {
      try {
        this.userId = localStorage.getItem('user_id');
        console.log(parseInt(this.userId));
        let response = await this.$apiFire('Station/onGetNotification', parseInt(this.userId))
        if (response !== null && typeof response === 'object' && Object.keys(response).length > 0) {
          console.log("2020");
          this.showNoti = true;
        } else {
          console.log("1010");
          this.showNoti = false;
        }
        console.log('11111', response);
        this.noti = response;
        console.log(this.noti.long_term_of_notification);
        console.log(this.noti.short_term_of_notification);

      } catch (error) {
        console.log(error);
      }
    },
    async openLocker() {
      try {
        // let response = await this.$apiFire('Station/onOpenLocker', parseInt(this.selectedBatteryForModal.id)) // locker id
        // let response = await this.$apiFire('Station/onOpenLocker/', { 'slot': this.selectedBatteryForModal.id });
        let response = await this.$apiFire('Station/onOpenLocker', this.selectedBatteryForModal.id);

        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    routeTo(route, battery) {
      if (!route) return
      console.log(route)
      this.$router.push({ name: route, params: { selectedBattery: battery } })
    },
    selectBattery(number) {
      console.log(number)
      this.selectedBattery = number;
    },
    openBatteryModal(battery) {
      if (battery.Isactive === 1) {
        if (battery.status === '1') {
          this.selectedBatteryForModal = battery;
          if (battery.battery_percent >= 80) {
            this.isModalOpenSelectBattery = true;
          } else if (battery.battery_percent < 80) {
            this.isModalBatteryCharging = true;
          }
        } else {
          this.isModalBatteryNotAvailable = true;
        }
      } else {
        this.isModalBatteryNotAvailable = true;
      }
    },
    closeBatteryModal() {
      this.isModalOpenSelectBattery = false;
      this.isModalBatteryCharging = false;
      this.isModalBatteryNotAvailable = false;
      this.isNotification = false;
    },
    confirmRoute() {
      if (this.selectedBatteryForModal) {
        // this.routeTo('StepChangeBattery', this.selectedBatteryForModal);
        this.$router.push({ name: 'StepChangeBattery', query: { slot: this.selectedBatteryForModal } })




        this.openLocker();
        //
        this.closeBatteryModal();
      }
    },
    showNotification() {
      this.isNotification = true;
    }
  },
  created() {
    this.fetchData();
    this.getRentalNotification();
    this.intervalUpdate = setInterval(() => {
      this.fetchData();
    }, 2700)
  },
  beforeDestroy() {
    clearInterval(this.intervalUpdate)
  }
}
</script>


<style scoped>
* {
  --width-size: 150px;
  --height-size: 60px;
}

.header-select-battery {
  width: 100%;
  padding: 30px 0 20px 30px;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
}

.container {
  position: relative;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  display: flex;
  gap: 8px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  z-index: 99;
}

.modal-content {
  background-color: #fff;
  width: 325px;
  padding: 20px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.modal-content img {
  width: 93px;
}

.noti-content {
  max-height: 550px;
  background-color: #fff;
  padding: 20px 24px;
  text-align: center;
  overflow: auto;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
}

.modal-detail {
  font-size: 14px;
  color: #C1C1C1;
}

.group-btn {
  display: flex;
  width: 100%;
}

.cancel-btn {
  font-size: 16px;
  padding: 8px 16px;
  color: #FE9900;
  border: 1px solid #FE9900;
  border-radius: 8px;
  width: 100%;
  margin-right: 5px;
}

.confirm-btn {
  font-size: 16px;
  padding: 8px 16px;
  color: #fff;
  background: linear-gradient(50deg, #FE9900 38.93%, #FFCD82 97.25%);
  border-radius: 8px;
  width: 100%;
}

.station-loader {
  display: flex;
  width: 100%;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: auto;
  margin-bottom: -15px;
  /* background: palegreen; */
  /* margin-right: -50px; */
}

.left-col-loader {
  /* margin-left: 65px; */
  margin: auto;
  /* margin-right: 6px; */
  left: 10px;
}

.right-col-loader {
  /* margin-right: 65px; */
  margin: auto;
  right: 10px;
}

.show-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: palegreen;
}

/* .dialog-modal {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    background: palegreen;
} */

.notification {
  background: #FF5354;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.noti-title {
  /* font-size: 14px;
  font-weight: 600; */
  font-size: 14px;
  font-weight: 600;
  width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.noti-detile {
  font-size: 12px;
  width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.noti-more {
  text-decoration-line: underline;
  font-size: 12px;
  cursor: pointer;
}
</style>